import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useAppSelector } from "../redux-toolkit/hooks";
import { allProjectMasterDetails } from "../redux-toolkit/slices/projectMasterSlice";
import { allKRAMasterDetails } from "../redux-toolkit/slices/kRAMasterSlice";

type Props = {
    apiResponse: any;
    // projectGraphData: any;
    // kraGraphData: any;
};

const TimeSheetGraph = (props: Props) => {
    const [projectGraphData, setProjectGraphData]: any = useState({ categories: [], series: [] });
    const [kraGraphData, setKraGraphData]: any = useState({ categories: [], series: [] });
    const [projectIdToName, setProjectIdToName] = useState({});
    const [kraIdToName, setKraIdToName] = useState({});

    const allProjectMasterData = useAppSelector(allProjectMasterDetails);
    const allKRAMasterData = useAppSelector(allKRAMasterDetails);

    useEffect(() => {
        setProjectIdToName(
            allProjectMasterData?.reduce((acc: any, project: any) => {
                acc[project.id] = project.name;
                return acc;
            }, {}) || {}
        );
    }, [allProjectMasterData]);

    useEffect(() => {
        setKraIdToName(
            allKRAMasterData?.reduce((acc: any, kra: any) => {
                acc[kra.id] = kra.name;
                return acc;
            }, {}) || {}
        );
    }, [allKRAMasterData]);

    const processGraphData = (entries = []) => {
        const projectData: any = {};
        const kraData: any = {};

        entries.forEach(({ project, kra, workHours }) => {
            const projectName = projectIdToName?.[project] || `Project ${project}`;
            const kraName = kraIdToName?.[kra] || `KRA ${kra}`;
            projectData[projectName] = (projectData[projectName] || 0) + workHours;
            kraData[kraName] = (kraData[kraName] || 0) + workHours;
        });

        return {
            projectGraph: {
                categories: Object.keys(projectData),
                series: Object.values(projectData),
            },
            kraGraph: {
                categories: Object.keys(kraData),
                series: Object.values(kraData),
            },
        };
    };

    useEffect(() => {
        if (props.apiResponse?.entriesDTOS && projectIdToName && kraIdToName) {
            const { projectGraph, kraGraph } = processGraphData(props.apiResponse.entriesDTOS);
            setProjectGraphData(projectGraph);
            setKraGraphData(kraGraph);
        }
    }, [props.apiResponse, projectIdToName, kraIdToName]);

    return (
        <div>
            {/* Project Bar Chart */}
            {projectGraphData?.categories?.length > 0 && (
                <ReactApexChart
                    options={{
                        chart: { type: "bar" },
                        xaxis: { categories: projectGraphData.categories },
                        title: { text: "Projects vs. Working Hours" },
                    }}
                    series={[
                        {
                            name: "Work Hours",
                            data: projectGraphData.series,
                        },
                    ]}
                    type="bar"
                    height={350}
                />
            )}

            {/* KRA Bar Chart */}
            {kraGraphData?.categories?.length > 0 && (
                <ReactApexChart
                    options={{
                        chart: { type: "bar" },
                        xaxis: { categories: kraGraphData.categories },
                        title: { text: "KRAs vs. Working Hours" },
                    }}
                    series={[
                        {
                            name: "Work Hours",
                            data: kraGraphData.series,
                        },
                    ]}
                    type="bar"
                    height={350}
                />
            )}

            {/* Project Pie Chart */}
            {projectGraphData?.categories?.length > 0 && (
                <ReactApexChart
                    options={{
                        chart: { type: "pie" },
                        labels: projectGraphData.categories,
                        title: { text: "Projects Distribution by Working Hours" },
                    }}
                    series={projectGraphData.series}
                    type="pie"
                    height={350}
                />
            )}

            {/* KRA Pie Chart */}
            {kraGraphData?.categories?.length > 0 && (
                <ReactApexChart
                    options={{
                        chart: { type: "pie" },
                        labels: kraGraphData.categories,
                        title: { text: "KRAs Distribution by Working Hours" },
                    }}
                    series={kraGraphData.series}
                    type="pie"
                    height={350}
                />
            )}
        </div>
    );
};

export default TimeSheetGraph;